<div class="permission-table__container" *transloco="let t">
  <div class="permission-table__header">
    <h3>
      {{ t('permission-table.item-type-' + itemType) }}
      @if (itemType === 'users' && itemCount) {
        <span>({{ itemCount }})</span>
      }
    </h3>

    <xi-fab
      icon="fab_plus"
      color="CX"
      buttonSize="normal"
      (onClick)="addItemClicked()"
      [disabled]="!canAddItem()"
      [matTooltip]="addToolTip"
      matTooltipPosition="left"
    >
    </xi-fab>
  </div>

  <div class="permission-table__column-scroll" [ngStyle]="{ height: scrollbarHeight }">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="name"
      matSortDirection="asc"
      matSortDisableClear
      class="permission-table__table"
    >
      <ng-container matColumnDef="name">
        <th class="permission-table__name-header" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ t('permission-table.name') }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ getName(element) }}
        </td>
      </ng-container>

      @if (hasEmail) {
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>
            <div class="permission-table__table-header-content">
              <div class="permission-table__table-header-border"></div>
              <span>{{ t('permission-table.email') }}</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ getEmail(element) }}
          </td>
        </ng-container>
      }

      <ng-container matColumnDef="executive">
        <th mat-header-cell *matHeaderCellDef>
          <div class="permission-table__table-header-content">
            <div class="permission-table__table-header-border"></div>
            <span>{{ t('permission-table.executive-view') }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-radio-button
            [name]="getId(element)"
            (change)="setUserPermissions(element, 'EXECUTIVE_READ_ONLY', 'READ_ONLY')"
            [disabled]="!canChangeUserPermission()"
            [checked]="userHasPermission(element, 'EXECUTIVE_READ_ONLY', 'READ_ONLY')"
          ></mat-radio-button>
        </td>
      </ng-container>

      <ng-container matColumnDef="read">
        <th mat-header-cell *matHeaderCellDef>
          <div class="permission-table__table-header-content">
            <div class="permission-table__table-header-border"></div>
            <span>{{ t('permission-table.read-only') }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-radio-button
            [name]="getId(element)"
            (change)="setUserPermissions(element, 'READ_ONLY')"
            [disabled]="!canChangeUserPermission()"
            [checked]="userHasPermission(element, 'READ_ONLY')"
          ></mat-radio-button>
        </td>
      </ng-container>

      <ng-container matColumnDef="all">
        <th mat-header-cell *matHeaderCellDef>
          <div class="permission-table__table-header-content">
            <div class="permission-table__table-header-border"></div>
            <span>{{ t('permission-table.all-access') }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-radio-button
            [name]="getId(element)"
            (change)="setUserPermissions(element)"
            [disabled]="!canChangeUserPermission()"
            [checked]="userHasPermission(element)"
          ></mat-radio-button>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div
            [matTooltip]="
              canRemoveItem(element)
                ? t('permission-table.remove-from-group')
                : t('permission-table.not-a-member')
            "
          >
            <xi-icon-button
              icon="trash"
              [disabled]="!canRemoveItem(element)"
              (onClick)="removeItemClicked(element)"
            ></xi-icon-button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="permission-table__no-table-data" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <div>
            <div class="permission-table__no-results-icon"><xi-svg svg="no"></xi-svg></div>
            @if (isAdmin) {
              <p class="permission-table__no-results-text">
                {{ t('permission-table.admin-cannot-be-added') }}
              </p>
            } @else {
              <p class="permission-table__no-results-text">
                @if (itemType === 'user-groups') {
                  <span>{{ t('permission-table.no-results') }}</span>
                }
                @if (itemType === 'users') {
                  <span>{{ t('permission-table.no-users') }}</span>
                }
              </p>
            }
          </div>
        </td>
      </tr>
    </table>
  </div>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 20, 50, 100]"
    [pageSize]="10"
    showFirstLastButtons
    aria-label="Select page"
  >
  </mat-paginator>
</div>
